const middleware = () => {
    return window?.configs?.['VUE_APP_MIDDLEWARE_URL'] || process.env['VUE_APP_MIDDLEWARE_URL']
}

const formatCurrency = (valueInCent) => {
    return (valueInCent/100).toFixed(2)
}

const formatDisplayDate = (date) => {
    if (!(date instanceof Date)) {
        date = new Date(date)
    }
    return [
        twoDigitNumber(date.getDate()),
        twoDigitNumber(date.getMonth() + 1),
        date.getFullYear(),
    ].join('.');
}

const convertLocalToUtcDate = (date) => {
    if (!(date instanceof Date)) {
        date = new Date(date)
    }
    return new Date(date - date.getTimezoneOffset(date)*60000)
}

const twoDigitNumber = (number) => {
    return ('0' + number).slice(-2)
}

const convertFileToDataUri = async (file) => {
    return new Promise((res, rej) => {
        // Encode the file using the FileReader API
        const reader = new FileReader()

        reader.onerror = rej
        reader.onloadend = () => {
            res(reader.result)
        }

        reader.readAsDataURL(file)
    })
}

const convertDataUriToFile = async (dataUri) => {
    const servedFile = await fetch(dataUri)
    const fileBlob   = await servedFile.blob()

    const file = new File([fileBlob], '', { type: fileBlob.type })
    const fileUrl = URL.createObjectURL(file)

    return fileUrl
}

const isSameDate = (dateOne, dateTwo) => {
    const sameDay = dateOne.getDate() === dateTwo.getDate()
    const sameMonth = dateOne.getMonth() === dateTwo.getMonth()
    const sameYear = dateOne.getFullYear() === dateTwo.getFullYear()
    return sameDay && sameMonth && sameYear
}

export default {
    middleware,
    formatCurrency,
    formatDisplayDate,
    convertLocalToUtcDate,
    twoDigitNumber,
    convertFileToDataUri,
    convertDataUriToFile,
    isSameDate
}